module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/cut-above-mobile-0376e3cb225b35fb16b1eeac5a57e50f.jpg";